import React from "react";
import "./HouseingTransform.css";

const LandscapingTransform = () => {
  return (
    <section className="workplace-cta-section">
      <div className="workplace-cta-container">
        <h2 className="workplace-cta-title">
          Create Beautiful Green Spaces
        </h2>

        <p className="workplace-cta-text">
          Get professional landscaping and horticulture services to enhance your
          property&apos;s outdoor appeal
        </p>

        <a
          href="https://wa.me/919899811123?text=Landscaping%20Services"
          target="_blank"
          rel="noopener noreferrer"
          className="workplace-cta-btn"
        >
          Beautify My Landscape →
        </a>
      </div>
    </section>
  );
};

export default LandscapingTransform;
